import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import CardsCarousel from '../CardsCarousel';
import HorizontalGrid from '../HorizontalGrid';

import './CardShelf.scss';

class CardShelf extends Component {
  render() {
    const {
      children,
      cellWidth,
      viewport,
      cardsInFrame,
      cellSpacing,
      parentClassName,
      popoutControls,
      dots,
      id,
      isRtl,
      arrows
    } = this.props;

    const baseClassName = 'pb-book-shelf';

    const classes = {
      [baseClassName]: true,
      [parentClassName]: parentClassName
    };

    return (
      <div className={classNames(classes)}>
        {
          viewport.medium
          ?
          <CardsCarousel
            viewport={viewport}
            popoutControls={popoutControls || viewport.xxlarge}
            cardsInFrame={cardsInFrame}
            cellSpacing={cellSpacing}
            dots={dots}
            isRtl={isRtl}
            arrows={arrows}
            >
            {children}
          </CardsCarousel>
          :
          <HorizontalGrid cellWidth={cellWidth} id={id} isRtl={isRtl}>{children}</HorizontalGrid>
        }
      </div>
    );
  }
}

CardShelf.propTypes = {
  children: PropTypes.node,
  viewport: PropTypes.object.isRequired,
  cellWidth: PropTypes.string
};

export default CardShelf;



// WEBPACK FOOTER //
// ./src/components/CardShelf/CardShelf.jsx